import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import illustration from '../assets/images/NotAuthorizes-cbconnect.svg';

/**
 * Écran affiché quand l'habilitation requise manque (403).
 *
 * L'ILLUSTRATION EST DÉCORATIVE, ET SON `alt` EST DONC VIDE. Le message est déjà
 * écrit juste en dessous ; le faire répéter par un lecteur d'écran n'ajouterait
 * rien et doublerait l'annonce. Même traitement que l'écran de maintenance, dont
 * cette page reprend la composition : illustration, titre, explication, issue.
 */
export default function AccesRefuse() {
  const { t } = useTranslation('commun');
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '60vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 12, padding: 24,
    }}>
      <img
        src={illustration}
        alt=""
        style={{ width: '100%', maxWidth: 320, height: 'auto', marginBottom: 4 }}
      />
      <div style={{ fontSize: 44, fontWeight: 800, color: '#1a6b3c' }}>403</div>
      <div style={{ fontSize: 17, fontWeight: 600 }}>{t('accesRefuse.titre')}</div>
      <div style={{ color: '#64748b', textAlign: 'center', maxWidth: 460 }}>
        {t('accesRefuse.explication')}
      </div>
      {/* DEUX ISSUES, ET ELLES NE FONT PAS DOUBLON. << Retour >> ramene d'ou l'on
          vient : c'est ce qu'on veut quand on a suivi un lien par erreur. Le tableau
          de bord est l'issue de secours, celle qui marche meme quand l'historique est
          vide - une adresse ouverte directement, un signet, un lien recu. Sans la
          seconde, un arrivant sans historique resterait coince. */}
      <div style={{ display: 'flex', gap: 10, marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: '#fff', color: '#1a6b3c', border: '1px solid #1a6b3c',
            borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14,
          }}
        >
          {t('accesRefuse.retour')}
        </button>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            background: '#1a6b3c', color: '#fff', border: 'none',
            borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14,
          }}
        >
          {t('accesRefuse.retourTableauDeBord')}
        </button>
      </div>
    </div>
  );
}
